
export type SupplierAccountsReceivableRequestType = {
    startDate: string,
    endDate: string,
    locationId: string,
    bookingNumber: string,
    transactionNumber: string,
    buyerId: string,
    isUnpaidOnly: boolean,
    sortBy: string,
    sortDir: string,
    page?: number,
    size?: number,
    buyerAccountId?: string,
    applyDates?: boolean,
};

/** Keys that make the report search all dates while filled (see `withDateRangeBypass`). */
export const SUPPLIER_ACCOUNTS_RECEIVABLE_DATE_BYPASS_KEYS: readonly (keyof SupplierAccountsReceivableRequestType)[] = ['bookingNumber', 'transactionNumber'];
